module.exports = __webpack_public_path__ + "assets/img/gpt_no_data.2b671764.png";